import Login from '../Login';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.scss';
import Private from '../Layout/Private';
import Public from '../Layout/Public';
import NotFound from '../NotFound';
import ForgottenPassword from '../ForgottenPassword';
import TestSuiteList from '../Test-Suites/List';
import Profile from '../Profile';
import { useServiceWorker } from '../useServiceWorker';
import { useContext, useEffect, useState } from 'react';
import Modal from '../Components/Modal';
import { EventContext } from '../Contexts/Events';
import Setup from '../Setup';
import Debug from '../Debug';
import Install from '../Install';
import Installed from '../Installed';
import TestSuiteView from '../Test-Suites/View';
import TestSuiteTestAssetView from '../Test-Suites/Tests/View/Assets/View';
import TestSuiteTestView from '../Test-Suites/Tests/View';

function App() {

  const { waitingWorker, showReload, reloadPage } = useServiceWorker();
  const [updateState, setUpdateState] = useState(false);
  const eventHandler = useContext(EventContext);

  useEffect(() => {
    if (showReload && waitingWorker) {
      setUpdateState(true);
    }
    const interval = setInterval(() => {
      eventHandler.trigger('notifications:request');
    }, 5000);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    }
  }, [waitingWorker, showReload, eventHandler]);

  return (
    <BrowserRouter>
      {updateState && (
        <Modal onDismiss={() => setUpdateState(false)} title="Update Available">
          <p>An update is available for the app.</p>
          <button className="PrimaryButton" onClick={() => reloadPage()}>Update</button>
        </Modal>
      )}
      <Routes>
        <Route path="/" element={<Private />}>
          <Route index element={<TestSuiteList />} />
          <Route path="setup" element={<Setup />} />
          {/* <Route path="test-suites/view/:testSuiteId/:testSuiteDate/:testId/:assetId" element={<TestSuiteTestAssetView />} />
          <Route path="test-suites/view/:testSuiteId/:testSuiteDate/:assetId" element={<TestSuiteTestView />} />
          <Route path="test-suites/view/:testSuiteId/:testSuiteDate" element={<TestSuiteView />} /> */}
          <Route path="test-suites/view/:clientId/:testSuiteDate/:testId/:assetId" element={<TestSuiteTestAssetView />} />
          <Route path="test-suites/view/:clientId/:testSuiteDate/site/:siteId/building/:buildingId/:assetId" element={<TestSuiteTestView />} />
          <Route path="test-suites/view/:clientId/:testSuiteDate/site/:siteId/building/:buildingId" element={<TestSuiteView />} />
          <Route path="test-suites/view/:clientId/:testSuiteDate/site/:siteId" element={<TestSuiteView />} />
          <Route path="test-suites/view/:clientId/:testSuiteDate" element={<TestSuiteView />} />
          <Route path="profile" element={<Profile />} />
          <Route path="debug" element={<Debug />} />
        </Route>
        <Route path="/" element={<Public />}>
          <Route path="install" element={<Install />} />
          <Route path="installed" element={<Installed />} />
          <Route path="login" element={<Login />} />
          <Route path="forgotten-password" element={<ForgottenPassword />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
